export default {"src":"/_next/static/media/walletconnect.4eb77d29.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};